import { FC } from 'react';
import classnames from 'clsx';

import styles from './LoadingSpinner.module.css';

export type Props = {
  className?: string;
  color?: 'white' | 'blue';
  size?: number;
};

export const LoadingSpinner: FC<Props> = ({
  className = '',
  color = 'white',
  size = 36,
}) => {
  return (
    <span
      className={classnames(styles.spinner, styles[color], className)}
      style={{ width: size, height: size }}
    />
  );
};
